"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FileStream_1 = __importDefault(require("../models/FileStream"));
var UploadEvent_1 = __importDefault(require("../uploadAdapters/UploadEvent"));
var SAME_TIME_UPLOADS_LIMIT = 3;
// NOTE! For uninvestigated reason /complete-upload backend returns 500 error
// for some files with chunkSize = 2mb
var chunkSize = 5 * 1024 * 1024; // 5 mb
var UploadDispatcher = /** @class */ (function () {
    function UploadDispatcher(uploadStrategy) {
        this.uploadStrategy = uploadStrategy;
        this.activeUploads = new Map();
        this.pendingUploads = new Map();
    }
    UploadDispatcher.prototype.upload = function (file, options) {
        return __awaiter(this, void 0, void 0, function () {
            var fileStream;
            return __generator(this, function (_a) {
                fileStream = new FileStream_1.default(file, options.chunkSize || chunkSize);
                return [2 /*return*/, this.uploadStream(fileStream, __assign(__assign({}, options), { chunkSize: options.chunkSize || chunkSize, fileName: file.name, fileSize: file.size }))];
            });
        });
    };
    /**
     * Upload file to helpers
     */
    UploadDispatcher.prototype.uploadStream = function (fileStream, options) {
        return __awaiter(this, void 0, void 0, function () {
            var upload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadStrategy.createUpload(fileStream, options.fileSize, options.fileName, __assign(__assign({}, options), { chunkSize: options.chunkSize || chunkSize }))];
                    case 1:
                        upload = _a.sent();
                        this.addActiveUpload(upload);
                        return [2 /*return*/, upload];
                }
            });
        });
    };
    /**
     * Add new file to upload processor
     */
    UploadDispatcher.prototype.addActiveUpload = function (upload) {
        upload.pause();
        this.pendingUploads.set(upload.getUuid(), upload);
        this.processUploads();
    };
    /**
     * Process upload stack
     */
    UploadDispatcher.prototype.processUploads = function () {
        if (this.activeUploads.size >= SAME_TIME_UPLOADS_LIMIT) {
            return;
        }
        if (this.pendingUploads.size === 0) {
            return;
        }
        var _a = __read(this.pendingUploads.entries().next().value, 2), upload = _a[1];
        this.activeUploads.set(upload.getUuid(), upload);
        this.pendingUploads.delete(upload.getUuid());
        upload.resume();
        this.handleUpload(upload);
    };
    /**
     * Handle uploading process and threading
     *
     * @param upload
     */
    UploadDispatcher.prototype.handleUpload = function (upload) {
        var _this = this;
        var uploadFinish = function (state) {
            _this.activeUploads.delete(state.uuid);
            _this.processUploads();
        };
        upload.on(UploadEvent_1.default.uploadDone, uploadFinish);
        upload.on(UploadEvent_1.default.cancel, uploadFinish);
        upload.on(UploadEvent_1.default.error, uploadFinish);
    };
    return UploadDispatcher;
}());
exports.default = UploadDispatcher;
//# sourceMappingURL=UploadDispatcher.js.map